<template>
    <div>
         <v-select
            v-model="selectedProtocol"
            :items="protocols"
            :label="$t('instance.data_model.form_editor.fields_types.ip_field.select_label')"
            required
        >
        </v-select>
        <v-text-field
            :label="$t('instance.data_model.form_editor.fields_types.ip_field.default_field')"
            type="text"
            v-model="valueCopy"
            :rules="rules"
            :disabled="readOnly"
            @change="emitValue"
        ></v-text-field>
    </div>
</template>

<script>

import FieldMixin from './field-mixin.vue';
export default {
    mixins: [FieldMixin],
    components: {

    },

    props: {

    },

    data (){
        return {
            protocols: ['ipv4','ipv6','ipv4_6'],
            selectedProtocol: 'ipv4',

        };
    },

    computed: {
        rulesList (){
            let rules = {
                ipv4: this.formActive ?[v => v === '' || this.ipv4Regex.test(v) || this.$t('instance.data_model.form_editor.fields_types.ip_field.rules.ipv4')]: [],
                ipv6: this.formActive ?[v => v === '' || this.ipv6Regex.test(v) || this.$t('instance.data_model.form_editor.fields_types.ip_field.rules.ipv6')]: [],
                ipv4_6: this.formActive ?[v => v === '' || this.ipv4_6Regex.test(v) || this.$t('instance.data_model.form_editor.fields_types.ip_field.rules.ip')]: [],
            };
            return {ip: rules[this.selectedProtocol]};
        },

        ipv4Regex (){
            return /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gm;
        },
        ipv6Regex (){
            return /^((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*::((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*|((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4})){7}$/g;
        },
        ipv4_6Regex (){
            return /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
        },
    },

    watch: {
        selectedProtocol (val){
            this.$emit('set-ip-protocol', val)
        },
    },
    created (){
        if(this.property.attributes.protocol){
            this.selectedProtocol = this.property.attributes.protocol;
        }else{
            this.$emit('set-ip-protocol', this.selectedProtocol)
        }
    },
    mounted (){
    },

    methods: {

        emitValue (){
            this.$emit('input', this.valueCopy);
            this.$emit('set-ip-protocol', this.selectedProtocol)
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/FormEditor/FieldsTypes/ip-field.vue